import { observer } from "mobx-react";
import { useEffect } from "react";
import { HEADER_TYPE } from "../../constants";
import { useStores } from "../../stores";
import {
	NP_Bell,
	NP_BellBadge,
	NP_Container,
	NP_Description,
	NP_EmptyState,
	NP_Item,
	NP_Items,
	NP_Title,
} from "./NotificationsPage.styled";
import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

interface NotificationsPageProps {}

export const NotificationsPage = observer(({}: NotificationsPageProps) => {
	const { settingsStore } = useStores();

	const { t } = useTranslation();

	useEffect(() => {
		(async () => {
			settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
		})();
	}, []);

	return (
		<NP_Container>
			<NP_EmptyState>
				<NP_Bell>
					<NP_BellBadge>0</NP_BellBadge>
					<Bell size={82} strokeWidth={1.4} />
				</NP_Bell>
				<NP_Title>{t("pages.notifications.title")}</NP_Title>
				<NP_Description>{t("pages.notifications.description")}</NP_Description>
				<NP_Items>
					<NP_Item>{t("pages.notifications.items.lessons")}</NP_Item>
					<NP_Item>{t("pages.notifications.items.subscriptions")}</NP_Item>
					<NP_Item>{t("pages.notifications.items.achievements")}</NP_Item>
					<NP_Item>{t("pages.notifications.items.account")}</NP_Item>
				</NP_Items>
			</NP_EmptyState>
		</NP_Container>
	);
});
